import styled from 'styled-components'
import { gridBreakPoints } from 'common/theme'

export const StyledYTDSectionBody = styled.div`
  padding: 2rem 20rem;
  min-height: 15rem;
  position: relative;
  @media screen and (max-width: ${gridBreakPoints.xxl}) {
    padding: 2rem 15rem;
  }
  @media screen and (max-width: ${gridBreakPoints.lg}) {
    padding: 2rem 5rem;
    .table-body td {
      min-width: 5rem;
    }
  }
`

export const StyledMyActivitySection = styled(StyledYTDSectionBody)`
  .table-head {
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    color: #cccccc;
    width: 100%;
    th {
      border-top: none;
      position: relative;
      font-weight: 400;
      border-right: 1px solid #ccc;
      &:first-child,
      :last-child {
        background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
        position: sticky;
        z-index: 2;
      }
      &:first-child {
        min-width: 18rem;
        left: 0;
      }
      &:last-child {
        right: 0;
        border-left: 1px solid #ccc;
      }
    }
  }
  table tbody > tr {
    &.table-row:nth-child(odd) > td {
      background: ${({ theme }) => theme.colors.tableStriped};
    }
    &.table-row:nth-child(even) > td {
      background: ${({ theme }) => theme.colors.inputBackgroundColor};
    }
    & > td:first-child,
    td:last-child {
      position: sticky;
      z-index: 1;
    }
    & > td:first-child {
      left: 0;
    }
    & > td:last-child {
      right: 0;
    }
  }
  @media (max-width: ${gridBreakPoints.sm}) {
    .table {
      font-size: 1.2rem;
    }
  }
`
